"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.sync = exports.scanAccounts = void 0;
var bignumber_js_1 = require("bignumber.js");
var currencies_1 = require("../../currencies");
var account_1 = require("../../account");
var operation_1 = require("../../operation");
var promise_1 = require("../../promise");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var api_1 = require("./api");
var tokens_1 = require("./tokens");
var logic_1 = require("./logic");
var getASAOperationAmount = function (transaction, accountAddress) {
    var assetAmount = new bignumber_js_1.BigNumber(0);
    if (transaction.type === api_1.AlgoTransactionType.ASSET_TRANSFER) {
        var details = transaction.details;
        var assetSender = details.assetSenderAddress
            ? details.assetSenderAddress
            : transaction.senderAddress;
        // Account is either sender or recipient (if both the balance is unchanged)
        if ((assetSender === accountAddress) !==
            (details.assetRecipientAddress == accountAddress)) {
            assetAmount = assetAmount.plus(details.assetAmount);
        }
        // Account is either sender or close-to, but not both
        if ((assetSender === accountAddress) !==
            (details.assetCloseToAddress &&
                details.assetCloseToAddress === accountAddress)) {
            if (details.assetCloseAmount) {
                assetAmount = assetAmount.plus(details.assetCloseAmount);
            }
        }
    }
    return assetAmount;
};
var getOperationAmounts = function (transaction, accountAddress) {
    var amount = new bignumber_js_1.BigNumber(0);
    var rewards = new bignumber_js_1.BigNumber(0);
    if (transaction.senderAddress === accountAddress) {
        var senderRewards = transaction.senderRewards;
        amount = amount.minus(senderRewards).plus(transaction.fee);
        rewards = rewards.plus(senderRewards);
    }
    if (transaction.type === api_1.AlgoTransactionType.PAYMENT) {
        var details = transaction.details;
        if (transaction.senderAddress == details.recipientAddress) {
            return {
                amount: amount,
                rewards: rewards
            };
        }
        if (transaction.senderAddress === accountAddress) {
            amount = amount.plus(details.amount);
        }
        if (details.recipientAddress == accountAddress) {
            var recipientRewards = transaction.recipientRewards;
            amount = amount.plus(details.amount).plus(recipientRewards);
            rewards = rewards.plus(recipientRewards);
        }
        if (transaction.closeRewards &&
            details.closeAmount &&
            details.closeToAddress === accountAddress) {
            var closeRewards = transaction.closeRewards;
            amount = amount.plus(details.closeAmount).plus(closeRewards);
            rewards = rewards.plus(closeRewards);
        }
    }
    return {
        amount: amount,
        rewards: rewards
    };
};
var getASAOperationType = function (transaction, accountAddress) {
    return transaction.senderAddress === accountAddress ? "OUT" : "IN";
};
var getOperationType = function (transaction, accountAddress) {
    if (transaction.type === api_1.AlgoTransactionType.ASSET_TRANSFER) {
        var details = transaction.details;
        if (details.assetAmount.isZero() &&
            transaction.senderAddress == details.assetRecipientAddress) {
            return "OPT_IN";
        }
        else if (details.assetCloseToAddress &&
            transaction.senderAddress == accountAddress) {
            return "OPT_OUT";
        }
        else {
            return "FEES";
        }
    }
    return transaction.senderAddress === accountAddress ? "OUT" : "IN";
};
var getOperationSenders = function (transaction) {
    return [transaction.senderAddress];
};
var getOperationRecipients = function (transaction) {
    var recipients = [];
    if (transaction.type === api_1.AlgoTransactionType.PAYMENT) {
        var details = transaction.details;
        recipients.push(details.recipientAddress);
        if (details.closeToAddress) {
            recipients.push(details.closeToAddress);
        }
    }
    else if (transaction.type === api_1.AlgoTransactionType.ASSET_TRANSFER) {
        var details = transaction.details;
        recipients.push(details.assetRecipientAddress);
        if (details.assetCloseToAddress) {
            recipients.push(details.assetCloseToAddress);
        }
    }
    return recipients;
};
var getOperationAssetId = function (transaction) {
    if (transaction.type === api_1.AlgoTransactionType.ASSET_TRANSFER) {
        var details = transaction.details;
        return details.assetId;
    }
};
var mapTransactionToOperation = function (tx, accountId, accountAddress, subAccounts) {
    var hash = tx.id;
    var blockHeight = tx.round;
    var date = new Date(parseInt(tx.timestamp) * 1000);
    var fee = tx.fee;
    var memo = tx.note;
    var senders = getOperationSenders(tx);
    var recipients = getOperationRecipients(tx);
    var _a = getOperationAmounts(tx, accountAddress), amount = _a.amount, rewards = _a.rewards;
    var type = getOperationType(tx, accountAddress);
    var assetId = getOperationAssetId(tx);
    var subOperations = subAccounts
        ? (0, account_1.inferSubOperations)(tx.id, subAccounts)
        : undefined;
    return {
        id: (0, operation_1.encodeOperationId)(accountId, hash, type),
        hash: hash,
        date: date,
        type: type,
        value: amount,
        fee: fee,
        senders: senders,
        recipients: recipients,
        blockHeight: blockHeight,
        accountId: accountId,
        subOperations: subOperations,
        extra: {
            rewards: rewards,
            memo: memo,
            assetId: assetId
        }
    };
};
var mapTransactionToASAOperation = function (tx, accountId, accountAddress) {
    var hash = tx.id;
    var blockHeight = tx.round;
    var date = new Date(parseInt(tx.timestamp) * 1000);
    var fee = tx.fee;
    var senders = getOperationSenders(tx);
    var recipients = getOperationRecipients(tx);
    var type = getASAOperationType(tx, accountAddress);
    var amount = getASAOperationAmount(tx, accountAddress);
    return {
        id: (0, operation_1.encodeOperationId)(accountId, hash, type),
        hash: hash,
        date: date,
        type: type,
        value: amount,
        fee: fee,
        senders: senders,
        recipients: recipients,
        blockHeight: blockHeight,
        accountId: accountId,
        extra: {}
    };
};
var getAccountShape = function (info, syncConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var address, initialAccount, currency, derivationMode, oldOperations, startAt, accountId, _a, round, balance, pendingRewards, assets, nbAssets, spendableBalance, newTransactions, subAccounts, newOperations, operations, shape;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                address = info.address, initialAccount = info.initialAccount, currency = info.currency, derivationMode = info.derivationMode;
                oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
                startAt = oldOperations.length
                    ? (oldOperations[0].blockHeight || 0) + 1
                    : 0;
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: address,
                    derivationMode: derivationMode
                });
                return [4 /*yield*/, (0, api_1.getAccount)(address)];
            case 1:
                _a = _b.sent(), round = _a.round, balance = _a.balance, pendingRewards = _a.pendingRewards, assets = _a.assets;
                nbAssets = assets.length;
                spendableBalance = (0, logic_1.computeAlgoMaxSpendable)({
                    accountBalance: balance,
                    nbAccountAssets: nbAssets,
                    mode: "send"
                });
                return [4 /*yield*/, (0, api_1.getAccountTransactions)(address, startAt)];
            case 2:
                newTransactions = _b.sent();
                return [4 /*yield*/, buildSubAccounts({
                        currency: currency,
                        accountId: accountId,
                        initialAccount: initialAccount,
                        initialAccountAddress: address,
                        assets: assets,
                        newTransactions: newTransactions,
                        syncConfig: syncConfig
                    })];
            case 3:
                subAccounts = _b.sent();
                newOperations = newTransactions.map(function (tx) {
                    return mapTransactionToOperation(tx, accountId, address, subAccounts);
                });
                operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
                shape = {
                    id: accountId,
                    xpub: address,
                    blockHeight: round,
                    balance: balance,
                    spendableBalance: spendableBalance,
                    operations: operations,
                    operationsCount: operations.length,
                    subAccounts: subAccounts,
                    algorandResources: {
                        rewards: pendingRewards,
                        nbAssets: nbAssets
                    }
                };
                return [2 /*return*/, shape];
        }
    });
}); };
function buildSubAccount(_a) {
    var parentAccountId = _a.parentAccountId, parentAccountAddress = _a.parentAccountAddress, token = _a.token, initialTokenAccount = _a.initialTokenAccount, newTransactions = _a.newTransactions, balance = _a.balance;
    return __awaiter(this, void 0, void 0, function () {
        var extractedId, tokenAccountId, oldOperations, newOperations, operations, tokenAccount;
        return __generator(this, function (_b) {
            extractedId = (0, tokens_1.extractTokenId)(token.id);
            tokenAccountId = parentAccountId + "+" + extractedId;
            oldOperations = (initialTokenAccount === null || initialTokenAccount === void 0 ? void 0 : initialTokenAccount.operations) || [];
            newOperations = newTransactions
                .filter(function (tx) { return tx.type === api_1.AlgoTransactionType.ASSET_TRANSFER; })
                .filter(function (tx) {
                var details = tx.details;
                return Number(details.assetId) === Number(extractedId);
            })
                .filter(function (tx) { return getOperationType(tx, parentAccountAddress) != "OPT_IN"; })
                .map(function (tx) {
                return mapTransactionToASAOperation(tx, tokenAccountId, parentAccountAddress);
            });
            operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
            tokenAccount = {
                type: "TokenAccount",
                id: tokenAccountId,
                parentId: parentAccountId,
                starred: false,
                token: token,
                operationsCount: operations.length,
                operations: operations,
                pendingOperations: [],
                balance: balance,
                spendableBalance: balance,
                swapHistory: [],
                creationDate: operations.length > 0
                    ? operations[operations.length - 1].date
                    : new Date(),
                balanceHistoryCache: account_1.emptyHistoryCache
            };
            return [2 /*return*/, tokenAccount];
        });
    });
}
function buildSubAccounts(_a) {
    var currency = _a.currency, accountId = _a.accountId, initialAccount = _a.initialAccount, initialAccountAddress = _a.initialAccountAddress, assets = _a.assets, newTransactions = _a.newTransactions, syncConfig = _a.syncConfig;
    return __awaiter(this, void 0, void 0, function () {
        var _b, blacklistedTokenIds, tokenAccounts, existingAccountByTicker, existingAccountTickers, _c, _d, existingSubAccount, _e, ticker, id;
        var e_1, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _b = syncConfig.blacklistedTokenIds, blacklistedTokenIds = _b === void 0 ? [] : _b;
                    if ((0, currencies_1.listTokensForCryptoCurrency)(currency).length === 0)
                        return [2 /*return*/, undefined];
                    tokenAccounts = [];
                    existingAccountByTicker = {};
                    existingAccountTickers = [];
                    if (initialAccount && initialAccount.subAccounts) {
                        try {
                            for (_c = __values(initialAccount.subAccounts), _d = _c.next(); !_d.done; _d = _c.next()) {
                                existingSubAccount = _d.value;
                                if (existingSubAccount.type === "TokenAccount") {
                                    _e = existingSubAccount.token, ticker = _e.ticker, id = _e.id;
                                    if (!blacklistedTokenIds.includes(id)) {
                                        existingAccountTickers.push(ticker);
                                        existingAccountByTicker[ticker] = existingSubAccount;
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_f = _c["return"])) _f.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    // filter by token existence
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, assets, function (asset) { return __awaiter(_this, void 0, void 0, function () {
                            var token, initialTokenAccount, tokenAccount;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        token = (0, currencies_1.findTokenById)((0, tokens_1.addPrefixToken)(asset.assetId));
                                        if (!(token && !blacklistedTokenIds.includes(token.id))) return [3 /*break*/, 2];
                                        initialTokenAccount = existingAccountByTicker[token.ticker];
                                        return [4 /*yield*/, buildSubAccount({
                                                parentAccountId: accountId,
                                                parentAccountAddress: initialAccountAddress,
                                                initialTokenAccount: initialTokenAccount,
                                                token: token,
                                                newTransactions: newTransactions,
                                                balance: asset.balance
                                            })];
                                    case 1:
                                        tokenAccount = _a.sent();
                                        if (tokenAccount)
                                            tokenAccounts.push(tokenAccount);
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    // filter by token existence
                    _g.sent();
                    // Preserve order of tokenAccounts from the existing token accounts
                    tokenAccounts.sort(function (a, b) {
                        var i = existingAccountTickers.indexOf(a.token.ticker);
                        var j = existingAccountTickers.indexOf(b.token.ticker);
                        if (i === j)
                            return 0;
                        if (i < 0)
                            return 1;
                        if (j < 0)
                            return -1;
                        return i - j;
                    });
                    return [2 /*return*/, tokenAccounts];
            }
        });
    });
}
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape });
//# sourceMappingURL=js-synchronization.js.map